import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return moment(value).format('DD-MM-YYYY');
  }
}


// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/utilities/app.formatdate.ts